module.exports = __webpack_public_path__ + "./images/footsteps.svg?5394cb1d258d8a17cf8f876b7b7d5e75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/footsteps.svg
// module id = 83
// module chunks = 0